import React from "react";
import ReactPlayer from "react-player";
import styles from "./styles.css";

const Player = ({ url, classname, loading, handleChange }) => {
   return (
      <div className={styles.wrapper} onClick={(e) => e.stopPropagation()}>
         <ReactPlayer
            onReady={() => handleChange("loading", false)}
            url={url}
            playsinline
            className={`${styles.player} ${classname}`}
            controls={true}
         />
         <div>{loading ? <p className={styles.loadingText}>Loading the video....</p> : null}</div>
      </div>
   );
};

export default Player;